export const integerFormatter = (value) => {
  if (value === '') {
    return value;
  }
  const intValue = parseInt(value, 10);
  return isNaN(intValue) ? 0 : intValue;
};
